export const defaultTheme = {
  colors: {
    primary: "#1B263B",
    accent: "#E63946",
    secondary: "#2A9D8F",
    background: "#F4F4F9",
    cardBackground: "#FFFFFF",
    textPrimary: "#0B0C10",
    textSecondary: "#6C757D",
    border: "#808080",
    borderInactive: "#a9a9a9",

    // Grayscale
    white: "#ffffff",
    black: "#000000",
  },
  fonts: {
    small: "14px", // 14px
    medium: "16px", // 16px
    title: "18px",
    logo: "22px",
  },
  screen: {
    large: "1500px",
    medium: "1200px",
    small: "800px",
  },
  size: {
    sendwichIconSize: "2rem",
  },
};
